<div
    class='agpr-tabs'
    [ngClass]="{
        'agpr-tabsStretch': style === tabsStyleTypesEnum.icon
    }"
>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <ul
        *ngIf="tabs?.length > 0"
        class="agpr-tabs-tabsGroup"
        [ngClass]="{'agpr-tabs-tabsGroupStretch': style === tabsStyleTypesEnum.icon}"
        role="tablist"
        [attr.aria-orientation]="orientation"
        (keyup)="onKeyUp($event)"
    >
        <div #tabLine class="agpr-tabListLine"></div>
        <li
            *ngFor="let tab of tabs"
            class="agpr-tabs-tab"
            [ngClass]="{
                'agpr-tabs-tab--selected': tab.selected,
                'agpr-tabs-tab--disabled': tab.disabled,
                'agpr-tabs-tabStretch': style === tabsStyleTypesEnum.icon
            }"
            [id]="tab.id"
            (click)="selectTab(tab)"
            role="tab"
            [attr.aria-controls]="tab.id + '.panel'"
            [attr.aria-selected]="tab.selected ? true : false"
        >
            <ng-container *ngIf="tabTemplate">
                <ng-container *ngTemplateOutlet="tabTemplate; context: {tab: tab}"></ng-container>
            </ng-container>
            <ng-container *ngIf="!tabTemplate">
                <span
                    *ngIf="tab.icon"
                    class="agpr-tabs-tabIcon"
                    [ngClass]="tab.icon"
                    aria-hidden="true"
                ></span>
                <span
                    class="agpr-tabs-heading"
                    [ngClass]="{
                        'agpr-tabs-tabStretchHeading--selected': tab.selected,
                        'agpr-tabs-tabStretchHeading': style === tabsStyleTypesEnum.icon
                    }"
                    role="heading"
                    [attr.aria-level]="tabsHeadingLevel"
                >
                    {{ tab.heading | localize }} {{tab.numberDescription?'(' + tab.numberDescription + ')':''}}
                </span>
                <span
                    *ngIf="tab.tooltip"
                    class="fa-regular fa-circle-info agpr-tabs-tabInfoIcon"
                    [pTooltip]="tab.tooltip| localize"
                    tooltipPosition="top"
                ></span>
            </ng-container>
        </li>
         @if (tabActions || addNewTab) {
            <li
                class="agpr-tabs-tabActions"
                id="tab_events"
                role="tab"
                attr.aria-controls="tab_events.panel"
            >
                <ng-content select="[tabActions]"></ng-content>
                @if (addNewTab) {
                    <agpr-button
                        class="agpr-tabs-tabIcon"
                        id="leftSidebar.amplifyButton"
                        icon="fa-regular fa-duotone fa-square-plus"
                        [style]="buttonTypes.icon"
                        [tooltip]="addNewDisabled ? '' : addNewTab"
                        [disabled]="addNewDisabled"
                        class="agpr-collapseSidebar-iconBtn"
                        (click)="addNewTrigger.next()"
                    ></agpr-button>
                }
            </li>
         }
    </ul>
    <div class="agpr-tabs-border"></div>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
    <div
        *ngIf="(!tabs || tabs.length < 1 || _selectedTabIndex !== null) && useContentContainer"
        class="agpr-tabs-contents"
    >
        <div
            *ngIf="tabHeader"
            class="agpr-tabs-header"
        >
            <ng-container *ngTemplateOutlet="tabHeader"></ng-container>
        </div>
        <agpr-scroll-panel #scrollPanel>
            <ng-content></ng-content>
        </agpr-scroll-panel>
        <ng-content select="[noScrollPanelContent]"></ng-content>
    </div>
</div>
